import { render, staticRenderFns } from "./excel-export.vue?vue&type=template&id=10b8eb0b"
import script from "./excel-export.vue?vue&type=script&lang=js"
export * from "./excel-export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports